<section>
  <tad-header></tad-header>
  <div class="tad-content">
    <router-outlet></router-outlet>
  </div>
  <tad-footer></tad-footer>
</section>
